module.exports = __webpack_public_path__ + "static/rabbit0-9756cc7e5d6d2753eede74d69763a999.png";